import { useEffect, useRef } from "react";
import bankingService, { BANK_AUTH_STATE_KEY } from "api/bankingService";

/**
 * Globalna obsługa powrotu z banku (Open Banking / PSD2) po SCA.
 *
 * Montowana wysoko w drzewie zalogowanej aplikacji, dzięki czemu callback
 * (`?bankingCode=&bankingState=`) jest obsłużony i wyczyszczony z adresu
 * natychmiast po załadowaniu — niezależnie od tego, na której trasie wylądował
 * użytkownik i kiedy zamontuje się rejestr „Operacje finansowe". Po finalizacji
 * `useFinalizeAuth` unieważnia zapytania (connections/accounts/operations), więc
 * zamontowany rejestr odświeży dane samoczynnie.
 *
 * Parametry są własne (nie `code`/`state`), aby nie kolidowały z obsługą
 * logowania OIDC (`react-oidc-context`).
 */
const BankingCallbackHandler = () => {
  const finalizeAuth = bankingService.useFinalizeAuth();
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return; // ochrona przed podwójnym wywołaniem (StrictMode)
    const params = new URLSearchParams(window.location.search);
    const code = params.get("bankingCode");
    const state = params.get("bankingState");
    if (!code || !state) return;
    handledRef.current = true;

    const expectedState = sessionStorage.getItem(BANK_AUTH_STATE_KEY);
    // wyczyść parametry z adresu natychmiast (zachowaj bieżącą ścieżkę)
    window.history.replaceState({}, "", window.location.pathname);

    if (expectedState && state !== expectedState) return; // ochrona anty-CSRF
    sessionStorage.removeItem(BANK_AUTH_STATE_KEY);

    finalizeAuth.mutate({ Code: code, State: state });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default BankingCallbackHandler;
